import Analysis from 'models/analysis';
import LayoutCheckbox from 'components/forms/layoutCheckbox';
import LayoutDatePicker from 'components/forms/layoutDatePicker';
import LayoutInput from 'components/forms/layoutInput';
import LayoutSelect from 'components/forms/layoutSelect';
import Loader from 'components/loader';
import LoadingButton from 'components/loadingBtn';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {balanceColumns} from 'helpers/fieldHelpers';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {scanInstructions, stripTypes} from 'helpers/scanHelpers';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';


class SourceTest extends React.Component {
  static defaultProps = {
    condition: true,
    stripsAvailable: [],
  };

  static propTypes = {
    accuscanInstructions: PropTypes.bool.isRequired,
    analysis: PropTypes.instanceOf(Analysis).isRequired,
    changeScanner: PropTypes.func.isRequired,
    toggleTestStrip: PropTypes.func.isRequired,
    condition: PropTypes.bool.isRequired,
    dataChanged: PropTypes.func.isRequired,
    edit: PropTypes.bool.isRequired,
    group: PropTypes.object.isRequired,
    handshakeComplete: PropTypes.bool.isRequired,
    manualScan: PropTypes.bool.isRequired,
    noScannersFound: PropTypes.bool.isRequired,
    oldAnalysis: PropTypes.object.isRequired,
    pool: PropTypes.object.isRequired,
    poolChanged: PropTypes.func.isRequired,
    scanners: PropTypes.array.isRequired,
    scanning: PropTypes.bool.isRequired,
    selectedStrips: PropTypes.array.isRequired,
    selectedScanner: PropTypes.any.isRequired,
    startScan: PropTypes.func.isRequired,
    stripsAvailable: PropTypes.array,
    scanResetDelay: PropTypes.number.isRequired,
    testers: PropTypes.array.isRequired,
    intl: intlShape.isRequired,
  };

  scannerSettings = () => {
    let {formatMessage} = this.props.intl;

    if (this.props.manualScan) {
      return <div/>;
    }

    let runScan = () => {
      this.props.startScan(
        this.props.selectedScanner,
        this.props.selectedStrips,
        this.props.pool.chemicalBaseTypeID
      );
    };

    if (!this.props.accuscanInstructions) {
      return <div>
        <div className='row'>
          <div className='col-md-6'>
            <FormattedMessage id="scanning.close.lid.before"/>
          </div>
          <div className='col-md-6'>
            <div className='form-group'>
              <LoadingButton
                className='btn btn-primary pull-right'
                onClick={runScan}
                loading={this.props.scanning}
                disabled={this.props.scanning}>
                {this.props.scanning ? formatMessage({id: 'general.scan.in.progress'}) : formatMessage({id: 'general.start.scan'})}
              </LoadingButton>
            </div>
          </div>
        </div>
        <hr/>
      </div>;
    }

    let stripSelection;

    if (!this.props.scanning) {
      stripSelection = this.props.scanResetDelay && this.props.scanResetDelay >= 0 ?
        <p>
          <scan className='b'><FormattedMessage id="scanning.resetting.accuscan"/></scan>
          {this.props.scanResetDelay} <FormattedMessage id="scanning.seconds.remaining"/></p> :
        this.props.stripsAvailable.map(strip => {
          return <span key={strip.key}
                       className='b'
                       onClick={this.toggleTestStrip.bind(this, strip.key)}>
            <div className='checkbox-wrapper'>
              <input type='checkbox'
                       value={strip.key}
                       checked={this.props.selectedStrips.indexOf(strip.key) !== -1}/>
              <label/>
            </div>
            <span className='pointer'>{strip.label}</span>
          </span>;
        });
    } else {
      stripSelection =
        <div>
          {!this.props.scanResetDelay || this.props.scanResetDelay <= 0 ?
            <p>
              <span className='b'>
                {stripTypes.find(s => s.key === this.props.selectedStrips[0]).label}
              </span> {formatMessage({id: 'general.scan.in.progress'}).toLowerCase()}...
            </p> : null}
          {this.props.scanResetDelay > 0 ? <p>
            <scan className='b'><FormattedMessage id="scanning.resetting.accuscan"/></scan>
            {this.props.scanResetDelay} <FormattedMessage id="scanning.seconds.remaining"/></p> : null}
          <p><FormattedMessage id="scanning.prepare.correct.test"/></p>
        </div>
      ;
    }

    return <div>
      <div className='row'>
        <div className='col-xs-12'>
          <label><FormattedMessage id="scanning.scanner.settings"/></label>
          <div className='form-group'>
            {stripSelection}
            <LoadingButton
              className='btn btn-primary pull-right'
              onClick={runScan}
              loading={this.props.scanning}
              disabled={this.props.scanning || this.props.selectedStrips.length === 0 || this.props.scanResetDelay > 0}>
              <FormattedMessage id="general.start.scan"/>
            </LoadingButton>
          </div>
        </div>
      </div>
      <hr/>
    </div>;
  };

  toggleTestStrip = type => {
    this.props.toggleTestStrip(type);
  };

  render() {
    let analysis = this.props.analysis;
    let analysisChanged = this.props.dataChanged;
    let pool = this.props.pool;
    let poolChanged = this.props.poolChanged;
    let topSection = [];

    let {formatMessage} = this.props.intl;

    topSection.push(<LayoutDatePicker value={analysis.modified ? moment(analysis.modified) : null}
                                      editMode={false}
                                      onChange={analysisChanged}
                                      dataKey='lastSource'
                                      key='lastSource'
                                      dateFormat='L'
                                      label={formatMessage({id: 'general.last.updated'})}/>);
    topSection.push(<LayoutSelect value={analysis.sourceWaterType}
                                  editMode={this.props.edit}
                                  dataChanged={analysisChanged}
                                  dataKey='sourceWaterType'
                                  key='sourceWaterType'
                                  keys={['City', 'Well', 'Other']}
                                  options={[
                                    formatMessage({id: 'general.city'}),
                                    formatMessage({id: 'general.well'}),
                                    formatMessage({id: 'general.other'}),
                                  ]}
                                  label={formatMessage({id: 'general.water.type'})}/>);
    topSection.push(<LayoutCheckbox value={pool.sourceConcern}
                                    editMode={this.props.edit}
                                    label={formatMessage({id: 'general.yes'})}
                                    hideLabel={!this.props.edit}
                                    dataChanged={poolChanged}
                                    dataKey='sourceConcern'
                                    key='sourceConcern'
                                    topLabel={formatMessage({id: 'source.source.concern'})}
                                    tooltip={formatMessage({id: 'source.source.tooltip'})}/>);

    let sourceFields = [];

    sourceFields.push(<LayoutInput label={formatMessage({id: 'general.tds'})}
                                   dataKey='tDS'
                                   key='tDS'
                                   value={analysis.tDS}
                                   dataChanged={analysisChanged}
                                   editMode={this.props.edit}
                                   group={this.props.group}
                                   validate={val => val >= 0 && val <= 9999}
                                   validateMessage={<FormattedMessage id='analysis.validate.dissolved.solids'/>}/>);

    sourceFields.push(<LayoutInput label={formatMessage({id: 'general.ph'})}
                                   dataKey='pH'
                                   key='pH'
                                   value={analysis.pH}
                                   dataChanged={analysisChanged}
                                   editMode={this.props.edit}
                                   validate={val => (!!val || val === 0) && val >= 0.1 && val <= 14.0}
                                   validateMessage={<FormattedMessage id='source.validate.ph'/>}/>);

    sourceFields.push(<LayoutInput label={formatMessage({id: 'general.copper'})}
                                   dataKey='copper'
                                   key='copper'
                                   value={analysis.copper}
                                   group={this.props.group}
                                   dataChanged={analysisChanged}
                                   editMode={this.props.edit}
                                   validate={val => (!!val || val === 0) >= 0 && val <= 99.9}
                                   validateMessage={<FormattedMessage id='source.validate.copper'/>}/>);

    sourceFields.push(<LayoutInput label={formatMessage({id: 'general.total.chlorine'})}
                                   dataKey='totalChlorine'
                                   key='totalChlorine'
                                   group={this.props.group}
                                   value={analysis.totalChlorine}
                                   dataChanged={analysisChanged}
                                   editMode={this.props.edit}
                                   validate={val => val >= 0 && val <= 99.9 &&
                                     (!analysis.freeChlorine || parseFloat(val) >= parseFloat(analysis.freeChlorine))}
                                   validateMessage={<FormattedMessage id='analysis.validate.total.chlorine'/>}/>);

    sourceFields.push(<LayoutInput label={formatMessage({id: 'general.total.alkalinity'})}
                                   dataKey='alkalinity'
                                   key='alkalinity'
                                   value={analysis.alkalinity}
                                   group={this.props.group}
                                   dataChanged={analysisChanged}
                                   editMode={this.props.edit}
                                   validate={val => val >= 0 && val <= 999}
                                   validateMessage={<FormattedMessage id='analysis.validate.total.alkalinity'/>}/>);

    sourceFields.push(<LayoutInput label={formatMessage({id: 'general.iron'})}
                                   dataKey='iron'
                                   key='iron'
                                   value={analysis.iron}
                                   group={this.props.group}
                                   editMode={this.props.edit}
                                   dataChanged={analysisChanged}
                                   validate={val => (!!val || val === 0) >= 0 && val <= 99.9}
                                   validateMessage={<FormattedMessage id='source.validate.iron'/>}/>);

    sourceFields.push(<LayoutInput label={formatMessage({id: 'general.free.chlorine'})}
                                   dataKey='freeChlorine'
                                   key='freeChlorine'
                                   value={analysis.freeChlorine}
                                   group={this.props.group}
                                   dataChanged={analysisChanged}
                                   editMode={this.props.edit}
                                   validate={val => analysis.chlorineDemandOnly || val >= 0 && val <= 999}
                                   validateMessage={<FormattedMessage id='source.validate.free.cl'/>}/>);

    sourceFields.push(<LayoutInput label={formatMessage({id: 'general.total.hardness'})}
                                   dataKey='hardness'
                                   key='hardness'
                                   value={analysis.hardness}
                                   dataChanged={analysisChanged}
                                   group={this.props.group}
                                   editMode={this.props.edit}
                                   validate={val => val >= 0 && val <= 9999}
                                   validateMessage={<FormattedMessage id='analysis.validate.total.hardness'/>}/>);

    sourceFields.push(<LayoutCheckbox topLabel={formatMessage({id: 'general.manganese'})}
                                      label={formatMessage({id: 'general.yes'})}
                                      dataKey='manganese'
                                      key='manganese'
                                      value={analysis.manganese}
                                      dataChanged={analysisChanged}
                                      editMode={this.props.edit}
                                      hideLabel={!this.props.edit}/>);

    let sourceColumns = balanceColumns(sourceFields, 3);

    let scannerErrors;

    if (this.props.noScannersFound) {
      scannerErrors = <p className='error'><FormattedMessage id="general.error.no.scanners"/></p>;
    }

    let output =
      <div className='container source-water-test'>
        {balanceColumns(topSection, 3)}
        {this.props.edit || analysis.waterTester !== formatMessage({id: 'scanning.select.tester'}) ?
          <div className='row row-highlighted'>
            <div className='col-xs-4'>
              <LayoutSelect label={formatMessage({id: 'general.tester'})}
                            editMode={this.props.edit}
                            dataChanged={analysisChanged}
                            validateMessage={<FormattedMessage id='analysis.select.name.tester' />}
                            group={this.props.group}
                            required={true}
                            validate={value => value !== formatMessage({id: 'scanning.select.tester'})}
                            dataKey='waterTester'
                            options={this.props.testers.map(t => t.name)}
                            value={analysis.waterTester || formatMessage({id: 'scanning.select.tester'})}/>
            </div>
            {this.props.edit ? <div className='col-xs-4'>
              <label className='main-text-color'><FormattedMessage id="general.scanner.type"/></label>
              <Loader loaded={this.props.handshakeComplete}>
                <select className='form-control'
                        value={this.props.selectedScanner}
                        onChange={this.props.changeScanner}>
                  {this.props.scanners.map(scanner => {
                    let label = scanner;

                    if (label === 'Manual') {
                      label = this.props.intl.formatMessage({id: 'general.manual'});
                    }

                    return <option key={scanner}
                                   value={scanner}>{label}</option>;
                  })}
                </select>
              </Loader>
            </div> : null}
            <div className='col-xs-4'>
              {scannerErrors}
            </div>
          </div> : null}
        {this.props.edit ? this.scannerSettings() : null}
        {this.props.edit ? scanInstructions(this.props.selectedStrips[0], this.props.accuscanInstructions) : null}
        {sourceColumns}
      </div>

    ;

    return this.props.condition ? output : null;
  }
}

export default bindLocaleUpdate(injectIntl(SourceTest));
